import http from '@/http'
const URL = '/admin/settings'

// export const setting = () => http.get(URL)
export const filters = (context) => http.get(URL + `/filters/${context}`)
export const status = () => http.get(URL + '/status')
export const refstatus = () => http.get(URL + '/refstatus')
export const statusSelect = () => http.get(URL + '/status-select')
export const attachmentTypes = () => http.get(URL + '/attachment-type')
// export const saveSetting = (payload) => http.post(URL + `/${payload.get('id')}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })

export default {
  filters,
  status,
  refstatus,
  statusSelect,
  attachmentTypes
}
